/**
 * @file    FileDropzone.css
 *
 *          Styles the file dropzone component.
 *
 * @author  Bryan Hoang <bryan@kingsds.network>
 * @date    July 2022
 */

.dropzone {
  /* Become the bounding box for the child label positioned absolutely. */
  position: relative;
  border: 1px dashed var(--content-hue-main);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 150px;
}

.dropzone label {
  position: absolute;
  top: -10px;
  left: 1em;
  background-color: #fff;
  padding: 0 0.5em;
}

/* State: File is selected */

.dropzone.fileSelected {
  height: initial;
  justify-content: left;
  gap: 10px;
  padding: 12px;
}
